function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  rx: 50,
  fill: "#E5FEF1"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 17.9541,
  y: 76.9376,
  width: 45.1714,
  height: 2.37744,
  rx: 1.18872,
  fill: "#A26542"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 20.3315,
  y: 71.3903,
  width: 40.4165,
  height: 5.54737,
  fill: "#D3C541"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 47.2759,
  y: 71.3903,
  width: 11.0947,
  height: 5.54737,
  fill: "#F1E46A"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 41.7285,
  y: 71.3903,
  width: 3.96241,
  height: 5.54737,
  fill: "#F1E46A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1296 71.39C21.1265 69.6402 22.5442 68.2201 24.294 68.2201H56.7857C58.5355 68.2201 59.9531 69.6402 59.95 71.39H21.1296Z",
  fill: "#774325"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 28.5454,
  y: 30.4546,
  width: 12.313,
  height: 17.1942,
  transform: "rotate(-50.1108 28.5454 30.4546)",
  fill: "#774325"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 24.5752,
  y: 37.4377,
  width: 3.78924,
  height: 14.3296,
  transform: "rotate(-50.1108 24.5752 37.4377)",
  fill: "#774325"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5375 41.8481C18.1361 40.6767 17.9496 38.5911 19.1209 37.1896L36.7823 51.9512C35.611 53.3527 33.5253 53.5392 32.1239 52.3678L19.5375 41.8481Z",
  fill: "#A26542"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7797 36.7725C22.3783 35.6012 20.2926 35.7877 19.1213 37.1892L36.7827 51.9507C37.9541 50.5493 37.7675 48.4636 36.3661 47.2923L23.7797 36.7725Z",
  fill: "#905634"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6654 35.109L25.8792 31.3394L41.3402 44.2618L37.6588 44.2974L26.6654 35.109Z",
  fill: "#A26542"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M28.227 30.1886C27.7764 29.812 27.1058 29.872 26.7292 30.3226L25.8796 31.3392L41.3405 44.2616L42.1902 43.245C42.5668 42.7944 42.5068 42.1238 42.0562 41.7472L28.227 30.1886Z",
  fill: "#905634"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  width: 3.78924,
  height: 14.3296,
  transform: "matrix(-0.641304 0.767286 0.767286 0.641304 42.6089 15.8615)",
  fill: "#774325"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M46.0551 10.1211C44.6537 8.9498 42.568 9.13634 41.3967 10.5378L59.0581 25.2994C60.2295 23.8979 60.0429 21.8123 58.6415 20.6409L46.0551 10.1211Z",
  fill: "#A26542"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M41.8134 15.1965C40.412 14.0251 40.2254 11.9395 41.3968 10.538L59.0582 25.2996C57.8869 26.701 55.8012 26.8876 54.3998 25.7162L41.8134 15.1965Z",
  fill: "#905634"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M40.6883 18.3317L36.839 18.227L52.3 31.1494L51.6817 27.5201L40.6883 18.3317Z",
  fill: "#A26542"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M36.123 20.7414C35.6724 20.3647 35.6124 19.6942 35.989 19.2436L36.8387 18.227L52.2997 31.1494L51.45 32.166C51.0734 32.6166 50.4028 32.6766 49.9522 32.3L36.123 20.7414Z",
  fill: "#905634"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M46.7974 40.5798L49.6305 37.1845L88.6025 63.7494C89.9364 64.8643 90.0129 66.9901 87.9465 69.6293C85.7159 72.1312 83.6103 72.4332 82.2764 71.3183L46.7974 40.5798Z",
  fill: "#774325"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M49.35 39.9146L50.4752 38.64L87.611 64.1481C88.6378 65.0063 88.6967 66.6428 87.106 68.6743C87.106 68.6743 54.4871 44.6074 49.35 39.9146Z",
  fill: "#905634"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M43.109 39.8409L48.2626 33.6749L51.3643 35.0874L45.0382 42.6562L43.109 39.8409Z",
  fill: "#A26542"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M51.4946 36.545C51.8611 36.1066 51.8027 35.454 51.3643 35.0875L45.0381 42.6564C45.4766 43.0229 46.1292 42.9645 46.4957 42.526L51.4946 36.545Z",
  fill: "#905634"
});

var SvgPolicyIcon = function SvgPolicyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPolicyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/policy-icon.d8975e5b.svg";
export { ForwardRef as ReactComponent };